var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCostTotal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8662 3.125L18.75 4.00881L16.4941 6.26463C17.3198 7.69218 17.651 9.35238 17.4363 10.9875C17.2217 12.6226 16.4732 14.141 15.3071 15.3071C14.141 16.4732 12.6226 17.2217 10.9875 17.4363C9.35238 17.651 7.69218 17.3198 6.26463 16.4941L4.00881 18.75L3.125 17.8662L5.21875 15.7727C4.85832 15.4737 4.5265 15.1418 4.22756 14.7812L2.13381 16.875L1.25 15.9912L3.50587 13.7354C2.68024 12.3078 2.34903 10.6476 2.56366 9.01253C2.7783 7.37745 3.52677 5.85897 4.69287 4.69287C5.85897 3.52677 7.37745 2.7783 9.01253 2.56366C10.6476 2.34903 12.3078 2.68024 13.7354 3.50587L15.9912 1.25L16.875 2.13381L14.7812 4.22731C15.1417 4.52634 15.4735 4.85825 15.7724 5.21875L17.8662 3.125ZM6.52769 15.1967C7.55549 15.8834 8.76387 16.25 10 16.25C11.657 16.2481 13.2456 15.589 14.4173 14.4173C15.589 13.2456 16.2481 11.657 16.25 10C16.25 8.76387 15.8834 7.55549 15.1967 6.52769C14.5099 5.49988 13.5338 4.6988 12.3918 4.22575C11.2497 3.75271 9.99307 3.62893 8.78069 3.87009C7.5683 4.11125 6.45466 4.7065 5.58058 5.58058C4.7065 6.45466 4.11125 7.5683 3.87009 8.78069C3.62893 9.99307 3.75271 11.2497 4.22575 12.3918C4.6988 13.5338 5.49988 14.5099 6.52769 15.1967ZM13.75 8.125H6.25V9.375H13.75V8.125ZM13.75 11.25H6.25V12.5H13.75V11.25Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostTotal);
export default __webpack_public_path__ + "static/media/cost-total.f9dbaf6f6dd934a1faf8545b41740e84.svg";
export { ForwardRef as ReactComponent };